export default __webpack_public_path__ + "3e8024292f933b9d5235bc6e01f30cea.png";